import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class, _descriptor, _descriptor2, _MyLocation;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import { action, observable, runInAction, makeObservable } from "mobx";
import { createRef } from "react";
import CesiumCartographic from "terriajs-cesium/Source/Core/Cartographic";
import URI from "urijs";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import isDefined from "../../../../Core/isDefined";
import TerriaError from "../../../../Core/TerriaError";
import GeoJsonCatalogItem from "../../../../Models/Catalog/CatalogItems/GeoJsonCatalogItem";
import CommonStrata from "../../../../Models/Definition/CommonStrata";
import createStratumInstance from "../../../../Models/Definition/createStratumInstance";
import { GLYPHS } from "../../../../Styled/Icon";
import StyleTraits from "../../../../Traits/TraitsClasses/StyleTraits";
import MapNavigationItemController from "../../../../ViewModels/MapNavigation/MapNavigationItemController";
export let MyLocation = (_dec = action.bound, _dec2 = action.bound, _class = (_MyLocation = class MyLocation extends MapNavigationItemController {
  constructor(props) {
    super();
    _defineProperty(this, "terria", void 0);
    _defineProperty(this, "itemRef", /*#__PURE__*/createRef());
    _defineProperty(this, "_marker", void 0);
    _initializerDefineProperty(this, "watchId", _descriptor, this);
    _initializerDefineProperty(this, "flown", _descriptor2, this);
    makeObservable(this);
    this.terria = props.terria;
    this._marker = new GeoJsonCatalogItem(createGuid(), props.terria);
    this.zoomToMyLocation = this.zoomToMyLocation.bind(this);
    this.handleLocationError = this.handleLocationError.bind(this);
    this.augmentedVirtualityEnabled = this.augmentedVirtualityEnabled.bind(this);
    this.followMeEnabled = this.followMeEnabled.bind(this);
  }
  get glyph() {
    return GLYPHS.geolocationThick;
  }
  get viewerMode() {
    return undefined;
  }
  getLocation() {
    const t = i18next.t.bind(i18next);
    if (navigator.geolocation) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };
      if (!this.augmentedVirtualityEnabled()) {
        // When Augmented Virtuality is not enabled then just get a single position update.
        navigator.geolocation.getCurrentPosition(this.zoomToMyLocation, this.handleLocationError, options);
      } else {
        // When Augmented Virtuality is enabled then we effectively toggle into watch mode and the position is repeatedly updated.
        this.watchId = navigator.geolocation.watchPosition(this.zoomToMyLocation, this.handleLocationError, options);
      }
    } else {
      this.terria.raiseErrorToUser(new TerriaError({
        sender: this,
        title: t("location.errorGettingLocation"),
        message: t("location.browserCannotProvide")
      }));
    }
  }
  zoomToMyLocation(position) {
    const t = i18next.t.bind(i18next);
    const longitude = position.coords.longitude;
    const latitude = position.coords.latitude;
    if (this.augmentedVirtualityEnabled()) {
      // Note: Specifying the value of 27500m here enables this function to approximately mimic the behaviour of
      //       the else case from the cameras initial view and when the viewer pan/zooms out to much.
      // We use the flag variable flown so that the user is flown to the current location when this function is
      // first fired, but subsequently the updates are jump location moves, since we assume that the movements are
      // small and flyTo performs badly when the increments are small (slow and unresponsive).
      this.terria.augmentedVirtuality.moveTo(CesiumCartographic.fromDegrees(longitude, latitude), 27500, !isDefined(this.flown));
      this.flown = true;
    } else {
      // west, south, east, north, result
      const rectangle = Rectangle.fromDegrees(longitude - 0.1, latitude - 0.1, longitude + 0.1, latitude + 0.1);
      this.terria.currentViewer.zoomTo(rectangle);
    }
    runInAction(() => {
      const name = t("location.myLocation");
      this._marker.setTrait(CommonStrata.user, "name", name);
      this._marker.setTrait(CommonStrata.user, "geoJsonData", {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [longitude, latitude]
        },
        properties: {
          title: t("location.location"),
          longitude: longitude,
          latitude: latitude
        }
      });
      // Need to specify rectangle for ideal zoom to work properly in 3D map.
      const closeUpRange = 0.002;
      this._marker.setTrait(CommonStrata.user, "rectangle", new Rectangle(longitude - closeUpRange, latitude - closeUpRange, longitude + closeUpRange, latitude + closeUpRange));
      this._marker.setTrait(CommonStrata.user, "style", createStratumInstance(StyleTraits, {
        "marker-size": "25",
        "marker-color": "#08ABD5",
        stroke: "#ffffff",
        "stroke-width": 3
      }));
      this._marker.setTrait(CommonStrata.user, "disableDepthTest", true);
      this.terria.workbench.add(this._marker);
    });
  }
  handleLocationError(err) {
    const t = i18next.t.bind(i18next);
    let message = err.message;
    if (message && message.indexOf("Only secure origins are allowed") === 0) {
      // This is actually the recommended way to check for this error.
      // https://developers.google.com/web/updates/2016/04/geolocation-on-secure-contexts-only
      const uri = new URI(window.location);
      const secureUrl = uri.protocol("https").toString();
      message = t("location.originError", {
        secureUrl: secureUrl
      });
    } else if (err.code === err.PERMISSION_DENIED) {
      message = t("location.permissionDenied");
    } else if (err.code === err.POSITION_UNAVAILABLE) {
      message = t("location.positionUnavailable");
    } else if (err.code === err.TIMEOUT) {
      message = t("location.timeout");
    }
    this.terria.raiseErrorToUser(new TerriaError({
      sender: this,
      title: t("location.errorGettingLocation"),
      message: message,
      showDetails: false
    }));
  }
  augmentedVirtualityEnabled() {
    return isDefined(this.terria.augmentedVirtuality) && this.terria.augmentedVirtuality.enabled;
  }
  followMeEnabled() {
    return !!isDefined(this.watchId);
  }
  disableFollowMe() {
    if (isDefined(this.watchId)) {
      navigator.geolocation.clearWatch(this.watchId);
      this.watchId = undefined;
      this.flown = undefined;
    }
  }
  handleClick() {
    if (this.followMeEnabled()) {
      this.disableFollowMe();
    } else {
      this.getLocation();
    }
  }
}, _defineProperty(_MyLocation, "id", "my-location"), _defineProperty(_MyLocation, "displayName", "MyLocation"), _MyLocation), _descriptor = _applyDecoratedDescriptor(_class.prototype, "watchId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "getLocation", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "getLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableFollowMe", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "disableFollowMe"), _class.prototype), _class);